/* Add to cart from a card without leaving the page (Sam, 2026-10-01).
 *
 * The collection, home, related and best-seller cards each carry a plain `{% form 'product' %}`
 * (snippets/dc-collection-card.liquid and friends), which posted natively and landed on /cart.
 * This posts the same form to /cart/add.js instead and dispatches `cart:item-add`, so
 * <dc-cart-toast> (assets/dc-cart-toast.js) shows "Added to cart · View cart" and refreshes the
 * header counts, exactly as after the buy box. A refused add (sold out, quantity limit) is shown
 * in the same toast through `dc:cart-error`.
 *
 * Only forms nobody else handles: the buy box sits inside <product-form>, which prevents the
 * default itself, and the bulk band posts from a click, not a form. */
(function () {
  function addUrl() {
    return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !form.matches || !form.matches('form.dc-form-host')) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return;
    event.preventDefault();

    var button = event.submitter || form.querySelector('[type="submit"]');
    if (button && button.getAttribute('aria-busy') === 'true') return;
    if (button) button.setAttribute('aria-busy', 'true');

    fetch(addUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
    })
      .then(function (response) {
        return response.json().then(function (json) { return { ok: response.ok, json: json }; });
      })
      .then(function (result) {
        if (!result.ok || result.json.status) {
          var message = result.json.description || result.json.message || (window.cartStrings && window.cartStrings.error) || '';
          document.dispatchEvent(new CustomEvent('dc:cart-error', { detail: { message: message } }));
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:item-add', {
          detail: { items: [result.json], context: form.dataset.eventContext },
        }));
      })
      .catch(function () {
        // No answer at all: fall back to the native post, which is what the card did before.
        form.submit();
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  });
})();
